export default (initialState = {}) => {
  return () => {
    return {
      date: null,
      dispatch_address: "",
      invc_date: null,
      invc_id: null,
      invc_number: "",
      invc_total_amount: 0,
      po_id: null,
      shipping_address: "",
      vehicle_number: "",
      bill_id: null,
      ...initialState,
    };
  };
};
